import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	collapsedIconLabel: {
		id: 'servicedesk-itsm-features.common.details-list.collapsed-icon-label',
		defaultMessage: 'Details collapsed',
		description: 'Accessibility text used for the collapsed icon',
	},
	expandedIconLabel: {
		id: 'servicedesk-itsm-features.common.details-list.expanded-icon-label',
		defaultMessage: 'Details expanded',
		description: 'Accessibility text used for the expanded icon',
	},
	automationDetails: {
		id: 'servicedesk-itsm-features.common.details-list.automation-details',
		defaultMessage: 'Automation Rules:',
		description: 'Bullet point for change management automations',
	},
});
